"use client";

import { CheckCircle, Info, SpinnerIcon, WarningCircle, XCircle } from "@phosphor-icons/react";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  // Uncomment if needed
  // ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";
import { Typography } from "@/components/ui/typography";
import { useToast } from "@/hooks/use-toast";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(
        ({
          // Uncomment if needed
          // action,
          customIcon,
          description,
          id,
          showIcon = true,
          // Uncomment if needed
          // title,
          ...props
        }) => {
          let variantIcon = <Info />;
          if (props.variant === "informative") {
            variantIcon = <Info />;
          }
          if (props.variant === "warning") {
            variantIcon = <WarningCircle />;
          }
          if (props.variant === "success") {
            variantIcon = <CheckCircle />;
          }
          if (props.variant === "error") {
            variantIcon = <XCircle />;
          }
          if (props.variant === "loading") {
            variantIcon = <SpinnerIcon className="animate-spin" />;
          }

          return (
            <Toast key={id} {...props}>
              <div className="flex gap-2 items-start">
                {showIcon && customIcon && <div className="[&_svg]:size-5">{customIcon}</div>}
                {showIcon && !customIcon && (
                  <div className="group-[.informative]:text-primary-600 group-[.warning]:text-warning-400 group-[.success]:text-success-400 group-[.error]:text-error-400 [&_svg]:size-5">
                    {variantIcon}
                  </div>
                )}
                <div className="grid gap-1">
                  {/* Uncomment if needed */}
                  {/* {title && <ToastTitle>{title}</ToastTitle>} */}
                  {description && (
                    <ToastDescription>
                      <Typography variant="caption 1">{description}</Typography>
                    </ToastDescription>
                  )}
                </div>
              </div>
              {/* Uncomment if needed */}
              {/* {action} */}
              <ToastClose />
            </Toast>
          );
        }
      )}
      <ToastViewport />
    </ToastProvider>
  );
}
